import React from 'react'

const PartnerLogo = ({logo}) => {

    if (logo) {
        return (
            <img className="img-fluid"
                alt="partner logo"
                src={logo}/>
        )
    } else {
        return (
            <div className="partner-logo__text d-flex flex-grow-1 justify-content-center align-items-center">
                Your Logo
            </div>
        )
    }

}

export default PartnerLogo



// WEBPACK FOOTER //
// ./src/components/subcomponents/PartnerLogo.js